import { ChangeDetectionStrategy, Component, EventEmitter,
  Input, OnChanges, Output } from '@angular/core';
import { TableColumn } from '../../../../models/app.model';



@Component({
  selector: 'app-income-objects-block',
  templateUrl: './income-objects-block.component.html',
  styleUrls: ['./income-objects-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncomeObjectsBlockComponent implements OnChanges {

  @Input() data: Array<any> = [];
  @Input() columns: Array<TableColumn> = [];
  @Input() title: string;
  @Input() hint: string;
  @Output() openDialog = new EventEmitter<any>();
  @Output() removeItem = new EventEmitter<any>();

  constructor() { }

  ngOnChanges() {
    //
  }

  open(data: any = null) {
    this.openDialog.emit(data);
  }

  remove(data) {
    this.removeItem.emit(data);
  }

}
